import React, { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { patchDraft, patchNewDraft } from '../restapi/messageService';

export const MessageContext = React.createContext(undefined);

export const MessageContextProvider = ({ children }) => {
  const [message, setMessage] = useState(undefined);

  const [lastModified, setLastModified] = useState(new Date());

  const refresh = () => setLastModified(new Date());

  const value = useMemo(
    () => ({
      message,
      newMessage: (eventId) => {
        patchNewDraft(eventId).then((resp) => {
          resp.json().then((newEmail) => {
            setMessage(newEmail);
            refresh();
          });
        });
      },
      changeMessage: (patch) => {
        setMessage((prevState) => ({
          ...prevState,
          ...patch,
        }));
      },
      saveMessage: (patch) => {
        patchDraft(message ? message.id : null, patch)
          .then((resp) => {
            if (resp.ok) {
              resp.json().then((newEmail) => {
                console.log(`did draft message ${message ? message.id : null}`, { newEmail });
                setMessage(newEmail);
                refresh();
              });
            } else {
              console.error(`could not patch draft message ${message ? message.id : null}`);
            }
          })
          .catch((error) => {
            console.error({ error });
            console.error(`could not patch draft message ${message ? message.id : null}`);
          });
      },
      extendMessage: (patch) => {
        const tmpMessage = { ...(message || {}) };
        tmpMessage.to = patch.to;
        if (patch.message && patch.message !== null) {
          if (tmpMessage.message === null || !tmpMessage.message) {
            tmpMessage.message = patch.message;
          } else {
            tmpMessage.message += patch.message;
          }
        }

        if (patch.subject && patch.subject !== null) {
          if (tmpMessage.subject === null || !tmpMessage.subject) {
            tmpMessage.subject = patch.subject;
          } else {
            tmpMessage.subject += patch.subject;
          }
        }
        if (!tmpMessage.attachments) {
          tmpMessage.attachments = patch.attachments;
        } else if (patch.attachments !== null) {
          patch.attachments.forEach((a) => tmpMessage.attachments.push(a));
        }
        // tmpMessage.subject = translate.insertPlainValues(tmpMessage.subject);
        patchDraft(patch.id, tmpMessage).then((resp) => {
          resp.json().then((newEmail) => {
            // newEmail.attachments = tmpMessage.attachments;
            setMessage(newEmail);
            refresh();
          });
        });
      },
      lastModified,
    }),
    [lastModified, message],
  );

  return (
    <MessageContext.Provider value={value}>
      <Outlet />
    </MessageContext.Provider>
  );
};

export const MessageContextProviderProxy = () => <MessageContextProvider />;
